//
$(function() {
    $(".gallery-content").after('<div class="gallery">');
    $(".gallery-content img").each(function(index) {
		var link1 = $(this).attr("src").replace("_medium.jpg", "_720x720.jpg");
        var link2 = $(this).attr("src").replace("_medium.jpg", "_1024x1024.jpg");
        var $link = $('<a href="' + link2 + '" class="image-link" ' +
		'style="background-image:url(' + link1 + ')" ></a>');
        $link.appendTo(".gallery").first();
    });
    $(".gallery-content").remove();
    $('.image-link').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
        /*
        mainClass: 'mfp-with-zoom', // this class is for CSS animation below

        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function(openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        }
        */

    });
});
